export default "__VITE_ASSET__DksDyYSf__"